import React, {useState, useEffect} from 'react'
import qs from 'qs'
import isEmpty from 'lodash/isEmpty'
import {RouteComponentProps} from "@reach/router";
import {IoLockClosedOutline} from 'react-icons/io5'
import FormField from "../components/FormField";
import {authenticate, authenticateDevice, getDeviceIdFromSession, totpAuthenticate} from "../_core/service";

interface LoginState {
  username: string
  password: string
  totp: string
  deviceId: string | null
  accessToken?: string
  step: 'login' | 'totp',
  error?: string | null
}

const Login = ({navigate, location}: RouteComponentProps) => {

  const params = qs.parse(location?.search || "", {ignoreQueryPrefix: true})
  const [state, setState] = useState<LoginState>({username: '', password: '', step: 'login', totp: '', deviceId: getDeviceIdFromSession()})

  const visit = (page:string) => {
    if (navigate) {
      navigate(page, {});
    } else {
      window.location.href = page
    }
  }

  useEffect(() => {
    if (params.fid) {
      authenticateDevice(params.fid as string).finally(() => {
        window.location.href = "/login"
      })
    }
  }, [params.fid])

  if (params.fid) {
    return <div>Verification en cours...</div>
  }

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setState((prevState => ({
      ...prevState, [evt.target.name]: evt.target.value
    })));
  }

  const handleSubmit = () => {
    let error: string | null = null;
    if (isEmpty(state.username)) {
      error = 'Merci de saisir votre identifiant de connexion'
    } else if (isEmpty(state.password)) {
      error = 'Merci de saisir votre mot de passe'
    }
    if (error) {
      setState((prevState => ({...prevState, error})));
    } else if (state.step === 'login') {
      authenticate(state.username, state.password, state.deviceId).then((response) => {
        if (response.totpRequired) {
          setState((prevState => ({...prevState, error: null, accessToken: response.token, step: 'totp'})));
        } else {
          visit('/')
        }
      }).catch((err) => {
        setState((prevState => ({...prevState, error: err.message})));
      })
    } else if (state.step === 'totp') {
      totpAuthenticate(state.accessToken!!, state.totp).then((response) => {
        visit('/')
      }).catch((err) => {
        setState((prevState => ({...prevState, error: err.message})));
      })
    }
  }
  
  /*const handleSubmit = () => {
    let error: string | null = null;

    // Vérification des champs login et mot de passe
    if (isEmpty(state.username)) {
      error = 'Merci de saisir votre identifiant de connexion';
    } else if (isEmpty(state.password)) {
      error = 'Merci de saisir votre mot de passe';
    }

    if (error) {
      setState((prevState => ({ ...prevState, error })));
    } else {
      // Authentification avec login et mot de passe uniquement
      authenticate(state.username, state.password, null).then((response) => {
        visit('/');
      }).catch((err) => {
        setState((prevState => ({ ...prevState, error: err.message })));
      });
    }
  };*/

  return (
    <div className="min-h-screen flex">
      {/* Section Image */}
      <div className="w-full bg-cover bg-center img-fluid"
        style={{
            backgroundImage: "url('/img/affiche_fidelium.jpeg')",
            backgroundSize: "contain", // Ajuste pour contenir l'image
            backgroundRepeat: "no-repeat", // Évite les répétitions
          }}>
      </div>
      {/* Section Login */}
      <div className="w-1/3 flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-96 space-y-8">
          <div className="bg-white p-10 shadow rounded">
            <div>
              <img className="mx-auto h-20 w-auto" src="/img/fidelium.png" alt="Logo Fidelium" />
              <h2 className="mt-6 text-center text-1xl font-extrabold">
                Dispositif technico-commercial exclusif
              </h2>
            </div>
            <h3 className="text-center text-xl pt-6">Accédez à votre espace client</h3>
            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div className="shadow-sm">
                {state.step === 'login' && (
                  <>
                    <FormField
                      name="username"
                      value={state.username}
                      onChange={handleChange}
                      label="Identifiant de connexion"
                    />
                    <FormField
                      type="password"
                      name="password"
                      value={state.password}
                      onChange={handleChange}
                      label="Mot de passe"
                    />
                  </>
                )}
              </div>
              <div className="text-red-500 font-bold text-center w-full text-sm">
                {state.error}
              </div>
              <div>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                    <IoLockClosedOutline size={18} />
                  </span>
                  <span>Se connecter</span>
                </button>
              </div>
            </form>
            <DownloadFideliumWin32 />
          </div>
        </div>
      </div>
    </div>
  )
}
  /*
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12">
      <div className="max-w-md w-96 space-y-8">
        <div className="bg-white p-10 shadow rounded">
          <div>
            <img className="mx-auto h-20 w-auto" src="/img/fidelium.png"
                 alt="Logo Fidelium"/>
            <h2 className="mt-6 text-center text-1xl font-extrabold">
              Dispositif technico-commercial exclusif
              d'aide au développement de la relation d'affaires entre Autodistribution Maroc et ses clients
              professionnels.
            </h2>
          </div>
          <h3 className="text-center text-xl pt-6">Accédez à votre espace client</h3>
          <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>

            <div className="shadow-sm">
              {state.step === 'login' && (
                <>
                  <FormField name="username" value={state.username} onChange={handleChange}
                             label="Identifiant de connexion"/>
                  <FormField type="password" name="password" value={state.password} onChange={handleChange}
                             label="Mot de passe"/>
                </>
              )}
              {state.step === 'totp' && (
                <FormField type="totp" name="totp" value={state.totp} onChange={handleChange}
                           label="Code PIN mobile"/>
              )}
            </div>

            <div className="text-red-500 font-bold text-center w-full text-sm">
              {state.error}
            </div>

            <div>
              <button type="button"
                      onClick={handleSubmit}
                      className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">

                <span className="absolute left-0 inset-y-0 flex items-center pl-3"><IoLockClosedOutline
                  size={18}/></span>
                <span>Se connecter</span>
              </button>
            </div>
          </form>
          {state.step !== 'totp' && <DownloadFideliumWin32/>}
        </div>
        <div className="clear-both text-xs text-center text-gray-500">
          <p>
            Fidelium est un programme d'Animation de Développement et de Fidélisation qui dote le revendeur et le
            garagiste d'une batterie de supports nécessaires pour son adaption à l'évolution de notre secteur.
          </p>
          <img className="mx-auto mt-5 h-6 w-auto " src="/img/admaroc.png" alt="Logo ADMaroc"/>
          <p className="mt-4">
            &copy; Auto-Distribution Maroc — {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </div>

  )
}
*/

const DownloadFideliumWin32 = () => (
  <div className="clear-both mt-4 w-full text-center">
    <a target="_blank" rel="noopener noreferrer" href="https://espace.fidelium.ma/Client_Fidelium.msi"
       className="font-medium text-sm text-indigo-600 hover:text-indigo-500">
      Télécharger le client Fidelium Win32
    </a>
  </div>
)

export default Login
